import { mainSiteUrl } from '@/mocks/categories';

export default function TemplateSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
                Free Resource
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
                Download Your Free Basetao Spreadsheet Template
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-6">
                Jumpstart your Basetao organization with a professionally designed spreadsheet template. Pre-built with product database fields, order tracking columns, shipping calculators, and expense dashboards — ready for you to customize.
              </p>

              <div className="space-y-3 mb-7">
                {[
                  'Product database with auto-calculating fields',
                  'Order tracker with status indicators',
                  'Shipping cost calculator & comparison tool',
                  'Expense dashboard with summary charts',
                ].map((feature) => (
                  <div key={feature} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs"></i>
                    </div>
                    <span className="text-sm text-foreground-700">{feature}</span>
                  </div>
                ))}
              </div>

              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Download Template <i className="ri-download-line"></i>
              </a>
            </div>

            <div className="relative">
              <div className="bg-background-100 rounded-lg border border-background-200/60 p-6">
                <div className="space-y-3">
                  {[...Array(3)].map((_, i) => (
                    <div key={i} className="flex items-center gap-3 p-3 bg-background-50 rounded-md border border-background-200/40">
                      <div className="w-8 h-8 rounded bg-accent-100 flex items-center justify-center text-accent-600 text-xs font-medium">{i + 1}</div>
                      <div className="flex-1">
                        <div className="h-2.5 bg-background-200 rounded w-3/4 mb-2"></div>
                        <div className="h-2 bg-background-200/70 rounded w-1/2"></div>
                      </div>
                      <div className="text-xs font-medium text-accent-600">Active</div>
                    </div>
                  ))}
                </div>
                <div className="mt-4 p-3 bg-accent-50 rounded-md border border-accent-200">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs text-foreground-600">Total Estimated</span>
                    <span className="text-sm font-semibold text-accent-700">$247.80</span>
                  </div>
                  <div className="h-1.5 bg-accent-200 rounded-full">
                    <div className="h-1.5 bg-accent-500 rounded-full w-3/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}